import * as React from "react";
import {Spinner} from "@amzn/awsui-components-react";

export default () => {
    return <Spinner size={"large"}/>;
}